var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.836,
    height: 30.836,
    viewBox: "0 0 30.836 30.836",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_icon",
    transform: "translate(20281 14630)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176055",
    "data-name": "Rectangle 176055",
    width: 28,
    height: 28,
    transform: "translate(-20281 -14630)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_profile-2user",
    "data-name": "vuesax/linear/profile-2user",
    transform: "translate(-20453 -14882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.91,11.4a2.335,2.335,0,0,0-.424,0,5.711,5.711,0,1,1,.424,0Z",
    transform: "translate(5.859 2.57)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.167,0a4.494,4.494,0,0,1,4.5,4.5,4.5,4.5,0,0,1-4.33,4.5,1.451,1.451,0,0,0-.334,0",
    transform: "translate(20.917 5.139)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2.332,1.763c-3.109,2.081-3.109,5.473,0,7.542a12.548,12.548,0,0,0,12.861,0c3.109-2.081,3.109-5.473,0-7.542A12.607,12.607,0,0,0,2.332,1.763Z",
    transform: "translate(3.013 16.944)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,7.709A6.215,6.215,0,0,0,2.518,6.591a3.254,3.254,0,0,0,0-5.486A6.39,6.39,0,0,0,.039,0",
    transform: "translate(23.564 17.988)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H30.836V30.836H0Z",
    transform: "translate(30.836 30.836) rotate(180)",
    fill: "none",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.27ee085654a30ab1f7c738dd76acaa75.svg";
export { ForwardRef as ReactComponent };